import React from 'react';
import { Line } from 'react-chartjs-2';
import { EventData } from '../../types/dashboard';

const CHART_OPTIONS = {
    maintainAspectRatio: false,
    legend: {
        display: false,
    },
    tooltips: {
        enabled: false,
    },
    elements: {
        point: {
            radius: 0,
        },
    },
    scales: {
        xAxes: [
            {
                gridLines: false,
                scaleLabel: false,
                ticks: {
                    display: false,
                },
            },
        ],
        yAxes: [
            {
                gridLines: false,
                scaleLabel: false,
                ticks: {
                    display: false,
                    suggestedMin: 0,
                    suggestedMax: 10,
                },
            },
        ],
    },
};

export default function LineChart(props: {
    title: string;
    data: EventData[];
    dataFilter: (data: EventData) => boolean;
    bgColor: string;
    lineColor: string;
}) {
    const data = props.data.filter(props.dataFilter).map((event) => parseInt(event.count));
    const chartData = {
        labels: data,
        datasets: [
            {
                backgroundColor: props.bgColor,
                borderColor: props.lineColor,
                borderWidth: 2,
                data,
            },
        ],
    };

    const total = chartData?.labels.length ?? 0;

    //TODO: calculate percentage change

    return (
        <>
            {chartData && (
                <div className="w-full md:w-1/3 px-2">
                    <div className="rounded-lg shadow-sm mb-4">
                        <div className="rounded-lg bg-white shadow-lg md:shadow-xl relative overflow-hidden">
                            <div className="px-3 pt-8 pb-10 text-center relative">
                                <h4 className="text-sm uppercase text-gray-500 leading-tight">{props.title}</h4>
                                <h5 className="text-3xl text-gray-700 font-semibold leading-tight my-3">{total}</h5>
                                <p className="text-xs text-red-500 leading-tight"></p>
                            </div>
                            <div className="absolute bottom-0 inset-x-0">
                                <Line data={chartData} options={CHART_OPTIONS} />
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
